var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnrolledStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52596 2.0851L11.7399 5.90832C12.1594 6.08239 12.42 6.47268 12.42 6.92687C12.42 7.38106 12.1594 7.77134 11.7399 7.94541L2.52596 11.7686C2.13848 11.9294 1.69986 11.8594 1.38151 11.5838C1.06376 11.3087 0.930887 10.8848 1.03474 10.4776L1.94017 6.92687L1.03474 3.37614C0.930887 2.9689 1.06378 2.54505 1.38153 2.26994C1.69928 1.99488 2.13779 1.92402 2.52596 2.0851Z",
    fill: "#FF453A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrolledStop);
export default __webpack_public_path__ + "static/media/enrolled-stop.ccf6cb11dd418a0d31be1efec096f0a3.svg";
export { ForwardRef as ReactComponent };